/**
 * The pre-filled description of a work order created from a plan activity.
 * The activity's comment follows on its own paragraph, so it reaches whoever
 * the work order is delegated to; the user may still edit the text before saving.
 */
export const maintenanceWorkOrderDescription = (
    componentTypeName: string,
    componentLabel?: string,
    comment?: string
): string => {
    const base = `Underhållsaktivitet för ${componentTypeName}`
        + (componentLabel ? ` (${componentLabel})` : '');
    const note = comment?.trim();
    return note ? `${base}\n\nKommentar från underhållsplanen: ${note}` : base;
};
